import { Link } from 'react-router-dom';
import { getPopularArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-platform-entry': 'https://readdy.ai/api/search-image?query=A%20modern%20browser%20window%20displaying%20a%20clean%20web%20interface%20with%20warm%20amber%20and%20cream%20color%20scheme%2C%20abstract%20geometric%20background%2C%20soft%20natural%20lighting%2C%20professional%20digital%20aesthetic%2C%20minimalist%20style&width=800&height=450&seq=home-art-1&orientation=landscape',
  'article-register-login': 'https://readdy.ai/api/search-image?query=A%20clean%20signup%20form%20interface%20on%20a%20warm%20beige%20background%2C%20abstract%20floating%20shapes%20in%20golden%20tones%2C%20soft%20lighting%2C%20modern%20minimalist%20UI%20design%2C%20professional%20look%2C%20no%20text&width=800&height=450&seq=home-art-2&orientation=landscape',
  'article-platform-overview': 'https://readdy.ai/api/search-image?query=Abstract%20digital%20dashboard%20with%20floating%20data%20cards%20and%20charts%2C%20warm%20golden%20and%20cream%20color%20palette%2C%20soft%20gradient%20background%2C%20clean%20minimalist%20tech%20aesthetic%2C%20professional%20and%20modern&width=800&height=450&seq=home-art-3&orientation=landscape',
};

export default function PopularArticles() {
  const popularArticles = getPopularArticles(3);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4">
              热门文章
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              精选内容推荐
            </h2>
          </div>
          <Link
            to="/category/guide"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {popularArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-xl border border-background-200/70 bg-background-50 overflow-hidden hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq] || articleImages['article-platform-entry']}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-background-50/85 backdrop-blur-sm text-primary-700">
                    {article.category === 'guide' ? '使用指南' : article.category === 'features' ? '平台功能' : '常见问题'}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 text-base group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}